import { Message } from '@/models/message'

type MessageIdentity = Pick<Message, 'id' | 'messageId' | 'clientMessageId'>

export function getMessageKey(message: MessageIdentity): string {
  return message.messageId || message.clientMessageId || message.id
}

export function getMessageAliases(message: MessageIdentity) {
  return [message.messageId, message.clientMessageId, message.id].filter(
    Boolean
  ) as string[]
}

export function messagesMatch(
  currentMessage: MessageIdentity,
  incomingMessage: MessageIdentity
) {
  if (
    incomingMessage.clientMessageId &&
    currentMessage.clientMessageId === incomingMessage.clientMessageId
  ) {
    return true
  }

  if (
    incomingMessage.messageId &&
    currentMessage.messageId === incomingMessage.messageId
  ) {
    return true
  }

  return currentMessage.id === incomingMessage.id
}

export function messageMatchesId(message: MessageIdentity, id: string) {
  return (
    message.messageId === id ||
    message.clientMessageId === id ||
    message.id === id
  )
}

export function addMessageIndexAliases(
  indexById: Map<string, number>,
  message: MessageIdentity,
  index: number
) {
  getMessageAliases(message).forEach((alias) => indexById.set(alias, index))
}
